// CertificateVerification.js
import React, { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import db from '../firebase'; // Adjust path as needed
import './CertificateVerification.css'; // We'll define styles below

const CertificateVerification = () => {
  const [certificateId, setCertificateId] = useState('');
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setCertificate(null);

    try {
      const q = query(collection(db, 'certificates'), where('certificateId', '==', certificateId));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        setCertificate({ id: doc.id, ...doc.data() });
      } else {
        setError('Certificate not found. Please check the ID and try again.');
      }
    } catch (err) {
      console.error('Error verifying certificate:', err);
      setError('An error occurred while verifying the certificate.');
    }
    setLoading(false);
  };

  return (
    <div className="verification-container">
      <header className="branding-header">
        <h1>SamSoftix Software House</h1>
        <p>Certificate Verification Portal</p>
        <img src="../assets/SamsoftixLogo.jpg" alt="SamSoftix Logo" className="logo" /> {/* Replace with actual logo path */}
      </header>

      <form onSubmit={handleVerify} className="verification-form">
        <label htmlFor="certId">Enter Certificate ID:</label>
        <input
          type="text"
          id="certId"
          value={certificateId}
          onChange={(e) => setCertificateId(e.target.value)}
          placeholder="e.g., CERT12345"
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify Certificate'}
        </button>
      </form>

      {error && <p className="error-message">{error}</p>}

      {certificate && (
        <div className="certificate-display">
          <div className="certificate-card">
            <div className="certificate-header">
              <h2>Certificate of Completion</h2>
              <p>SamSoftix Software House</p>
            </div>
            <div className="certificate-body">
              <p>
                This is to certify that <strong>{certificate.name}</strong> has successfully completed the course titled <strong>{certificate.courseName}</strong>, 
                conducted from <strong>{certificate.startDate}</strong> to <strong>{certificate.endDate}</strong>. 
                The candidate achieved a grade of <strong>{certificate.grade}</strong>.
              </p>
              <p>
                <strong>Description:</strong> {certificate.description}
              </p>
              <p>
                <strong>Certificate ID:</strong> {certificate.certificateId}
              </p>
              {certificate.feePending ? (
                <p className="fee-status fee-warning">
                  <strong>Status:</strong> Certificate is valid, but fees are pending. Please contact SamSoftix for payment details to fully activate this certificate.
                </p>
              ) : (
                <p className="fee-status fee-clear">
                  <strong>Status:</strong> All fees have been cleared. This certificate is fully verified and active.
                </p>
              )}
            </div>
            <div className="certificate-footer">
              <p>Issued on behalf of SamSoftix Software House</p>
              <p>For inquiries, contact us at info@samsoftix.com</p>
              <div className="signature">
                <p>___________________________</p>
                <p>Authorized Signature</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificateVerification;